import { Button } from '@ps/isp-web-component-library';
import { useTrackers } from '@ps/web-shared-analytics';
import { Translation, useTrackingLabel } from '@ps/web-shared-components';
import React from 'react';

import useOddsChanges from '../../../../../../../../hooks/useOddsChanges';

import { TXTWCL_Accept_Price_Changes } from './AcceptPriceButton.messages.json';

const AcceptPriceButton: React.FC = () => {
  const { acceptOddsChanges } = useOddsChanges();
  const { buttonPressed } = useTrackers();
  const buttonName = useTrackingLabel(TXTWCL_Accept_Price_Changes);

  return (
    <Button
      onClick={() => {
        buttonPressed({ buttonName });
        acceptOddsChanges();
      }}
      variant="brand-update"
      size="medium"
    >
      <Translation {...TXTWCL_Accept_Price_Changes} />
    </Button>
  );
};

export default AcceptPriceButton;
